import React, {useState} from "react";

import imageUploadPlaceholder from '../../../../../../assests/img/sb3_image_upload_placeholder_small.png'
import { toast } from 'Components/DesignSystem/Toast/useToast';
import {useISRContext} from "../../../Hooks/useISRContext";

type TFieldProps = {
    projectId?: string
    onClose: () => void;
    onSubmit: (url: string) => void;
}

const EditCategoryImageDialog = ({projectId, onClose, onSubmit}: TFieldProps) => {

    const isrContext = useISRContext();

    const [file, setFile] = useState(null);
    const [webUrl, setWebUrl] = useState("");
    const [loading, setLoading] = useState(false);

    const handleFileChange = async (event: any) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setWebUrl('');
            const validFormats = ["image/jpeg", "image/png", "image/gif", "image/webp"];
            if (!validFormats.includes(selectedFile.type)) {
                toast.error('Only image files (JPEG, PNG, GIF, WEBP) are allowed');
                setFile(null);
            } else {
                setFile(selectedFile);
            }
        }
    };

    const handleChangeUrl = (value: string) => {
        setWebUrl(value);
    }

    return (
        <div id='sb3-category-image-edit' className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className={`tw-bg-white tw-rounded tw-shadow-md tw-w-[613px] tw-h-auto`}>
                <div className='tw-flex tw-items-center'>
                    <h2 className={`tw-text-sm tw-font-semibold tw-my-3 tw-px-3 `}>{'Thumbnail image'}</h2>
                </div>
                <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6]`}/>
                <div className={`tw-mx-[4px] tw-pt-4 tw-px-[16px] tw-pt-[11px] tw-pb-[20px] tw-rounded`}>
                    <div className="tw-flex-auto tw-flex tw-items-center">
                        <img className="tw-object-cover tw-w-[75px] tw-h-[75px]" src={file != null ? URL.createObjectURL(file) : webUrl.length > 0 ? webUrl : imageUploadPlaceholder} alt={'categoryImage'}/>
                        {file == null ? <><input data-testid="components-editcategoryimagedialog-input-1" id='sb3-category-image-edit-remove-file-input' type="file"
                                                 accept="image/jpeg, image/png, image/gif, image/webp"
                                                 className="hidden" onChange={handleFileChange}/><label
                                id='sb3-category-image-edit-choose-file'
                                htmlFor="sb3-category-image-edit-remove-file-input"
                                className="samll-outline-btn  tw-mx-[16px] tw-pt-0.5 tw-cursor-pointer"> Choose
                                File </label></> :
                            <div role="button" data-testid="components-editcategoryimagedialog-div-1" id='sb3-category-image-edit-remove-file' onClick={() => setFile(null)}
                                 className="tw-text-[#bf2600] tw-text-sm font-normal tw-leading-tight tw-ms-[15px] tw-p-[18px] tw-cursor-pointer">Remove</div>}
                    </div>

                    <div className="tw-text-[#747493] tw-text-xs tw-font-bold tw-leading-tight tw-mb-[4px] tw-mt-[16px] tw-mx-0.5">Image URL</div>
                    <input data-testid="components-editcategoryimagedialog-input-2" id='sb3-category-image-edit-input-url' disabled={file != null}
                           className={`tw-w-full tw-rounded tw-box-border tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-grey-550 focus:tw-outline-none ${file != null ? 'tw-bg-[#f4f5f7] tw-text-[#969fae]`' : ''}`}
                           type='text'
                           value={webUrl}
                           onChange={(e) => {
                               handleChangeUrl(e.target.value)
                           }}
                           placeholder={'Enter URL'}
                    />

                    <div id={`edit-category-dialog-right-actions`} className='tw-flex tw-gap-2 tw-justify-end tw-mt-[16px]'>
                        <button data-testid="components-editcategoryimagedialog-button-3" id='sb3-category-image-edit-button-cancel' className='samll-outline-btn' onClick={onClose}>Cancel</button>
                        <button data-testid="components-editcategoryimagedialog-button-4" id='sb3-category-image-edit-button-save'
                                disabled={loading || (file == null && webUrl.length === 0)} onClick={async () => {
                            if (file != null) {
                                setLoading(true);
                                const url = await isrContext.uploadImage(file, projectId);
                                setLoading(false);
                                onSubmit(url);
                            } else {
                                if (!isrContext?.isValidUrl(webUrl)) {
                                    toast.error('Invalid image URL');
                                    return;
                                }
                                onSubmit(webUrl);
                            }
                        }} className={`small-filled-btn`}>{loading ? 'Uploading...' : 'Save'}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default EditCategoryImageDialog;